import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import {
  BASE_URL,
  SAAS_APPLICATION,
  saas_apiUrl,
  saas_apiParams,
  saas_form_data,
} from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import Switch from "react-switch";
import "react-toastify/dist/ReactToastify.css";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const OrderTypeCrud = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {
    //order type
    orderTypeList,
    setOrderTypeList,
    setPaginatedOrderType,
    orderTypeForSearch,
    setOrderTypeForSearch,

    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);

  // States hook here
  //new group
  let [newOrderType, setNewOrderType] = useState({
    name: "",
    status: "",
    address: "",
    edit: false,
    editSlug: null,
    uploading: false,
  });

  //search result
  let [searchedOrderType, setSearchedOrderType] = useState({
    list: null,
    searched: false,
  });

  // order type limit check
  let [checkOrderTypeLimitState, setCheckOrderTypeLimitState] = useState("");

  // check order type limit
  const checkOrderTypeLimit = () => {
    // check how many orders are left
    const url =
      saas_apiUrl + "/api/user-order-type-limit-check?" + saas_apiParams;
    axios
      .get(url)
      .then((res) => {
        setCheckOrderTypeLimitState(res.data);
      })
      .catch(() => {
        return "NO data";
      });
  };

  const [currentStatus, setCurrentStatus] = useState(null);

  //useEffect == componentDidMount
  useEffect(() => {}, []);

  //set name, phn no, address hook
  const handleSetNewOrderType = (e) => {
    setNewOrderType({ ...newOrderType, [e.target.name]: e.target.value });
  };

  //Save New order type
  const handleSaveNewOrderType = (e) => {
    e.preventDefault();
    setNewOrderType({
      ...newOrderType,
      uploading: true,
    });
    const orderTypeUrl = BASE_URL + `/settings/new-order-type`;
    let formData = new FormData();
    formData.append("name", newOrderType.name);
    formData.append("status", newOrderType.status);
    formData.append("address", newOrderType.address);
    return axios
      .post(orderTypeUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (SAAS_APPLICATION == "YES") {
          // after send api req decremeny by one
          const url = saas_apiUrl + "/api/user-order-type-limit-decrement"; // replace with base url (prince.thetestserver.xyz)
          axios
            .post(url, saas_form_data)
            .then((res) => {
              console.log(res);
            })
            .catch(() => {
              return "NO data";
            });
        }
        setNewOrderType({
          name: "",
          status: "",
          address: "",
          edit: false,
          editSlug: null,
          uploading: false,
        });
        setOrderTypeList(res.data[0].data);
        setOrderTypeForSearch(res.data[1]);
        setSearchedOrderType({
          ...searchedOrderType,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Order type has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        setNewOrderType({
          ...newOrderType,
          uploading: false,
        });
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //set edit true & values
  const handleSetEdit = (slug) => {
    let orderType = orderTypeForSearch.filter((item) => {
      return item.slug === slug;
    });
    setNewOrderType({
      ...newOrderType,
      name: orderType[0].name,
      status: orderType[0].status,
      // address: orderType[0].address,
      // editSlug: orderType[0].slug,
      // edit: true,
    });
  };

  //update order type
  const handleUpdateOrderType = (e) => {
    e.preventDefault();
    setNewOrderType({
      ...newOrderType,
      uploading: true,
    });
    const orderTypeUrl = BASE_URL + `/settings/update-order-type`;
    let formData = new FormData();
    formData.append("name", newOrderType.name);
    formData.append("status", newOrderType.status);
    // formData.append("address", newOrderType.address);
    // formData.append("editSlug", newOrderType.editSlug);
    return axios
      .post(orderTypeUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewOrderType({
          name: "",
          status: "",
          // address: "",
          // edit: false,
          // editSlug: null,
          // uploading: false,
        });
        setOrderTypeList(res.data[0].data);
        setOrderTypeForSearch(res.data[1]);
        setSearchedOrderType({
          ...searchedOrderType,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Order type has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        setNewOrderType({
          ...newOrderType,
          uploading: false,
        });
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //search order type here
  // const handleSearch = (e) => {
  //   let searchInput = e.target.value.toLowerCase();
  //   if (searchInput.length === 0) {
  //     setSearchedOrderType({ ...searchedOrderType, searched: false });
  //   } else {
  //     let searchedList = orderTypeForSearch.filter((item) => {
  //       let lowerCaseItemName = item.name.toLowerCase();
  //       let lowerCaseItemPhnNo =
  //         item.status !== null && item.status.toLowerCase();
  //       let lowerCaseItemAddress =
  //         item.address !== null && item.address.toLowerCase();
  //       return (
  //         lowerCaseItemName.includes(searchInput) ||
  //         (lowerCaseItemPhnNo && lowerCaseItemPhnNo.includes(searchInput)) ||
  //         (lowerCaseItemAddress && lowerCaseItemAddress.includes(searchInput))
  //       );
  //     });
  //     setSearchedOrderType({
  //       ...searchedOrderType,
  //       list: searchedList,
  //       searched: true,
  //     });
  //   }
  // };

  //delete confirmation modal of order type
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteOrderType(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete order type here
  const handleDeleteOrderType = (slug) => {
    setLoading(true);
    const orderTypeUrl = BASE_URL + `/settings/delete-order-type/${slug}`;
    return axios
      .get(orderTypeUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data === "user") {
          setLoading(false);
          toast.error(
            `${_t(t("Please disable all the user of this order type first"))}`,
            {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            }
          );
        } else {
          setOrderTypeList(res.data[0].data);
          setOrderTypeForSearch(res.data[1]);
          setSearchedOrderType({
            ...searchedOrderType,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(
            `${_t(t("Order type has been deleted successfully"))}`,
            {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            }
          );
        }
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  const handleStatus = (id, val) => {
    val === "On" ? (val = "Off") : (val = "On");
    setLoading(true);
    // setNewDefault({ ...newDefault, uploading: true });
    // setDataPaginating(true);
    const orderTypeUrl = BASE_URL + `/settings/update-order-types`;
    let formData = new FormData();
    formData.append("id", id);
    formData.append("status", val);
    return axios
      .post(orderTypeUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setOrderTypeList(res.data[0]);
        // setNavCurrencyList(res.data[1]);
        // setCurrencyListForSearch(res.data[1]);
        // setSearchedCurrencies({
        //   ...searchedCurrencies,
        //   list: res.data[1],
        //   searched: false,
        // });
        setLoading(false);
        // setDataPaginating(false);
        // setNewDefault({ ...newDefault, uploading: false });
        toast.success(`${_t(t("Order Type has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Order Types"))}</title>
      </Helmet>

      {/* Add modal */}
      <div className="modal fade" id="addOrderType" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newOrderType.edit
                    ? _t(t("Add new order type"))
                    : _t(t("Update order type"))}
                </h5>
              </div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newOrderType.uploading === false ? (
                <div key="fragment-order-type-1">
                  <form
                    onSubmit={
                      !newOrderType.edit
                        ? handleSaveNewOrderType
                        : handleUpdateOrderType
                    }
                    autoComplete="off"
                  >
                    <div>
                      <label htmlFor="name" className="form-label">
                        {_t(t("Name"))}{" "}
                        <small className="text-primary">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="e.g. Uttara Order type"
                        value={newOrderType.name || ""}
                        required
                        onChange={handleSetNewOrderType}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="status" className="form-label">
                        {_t(t("Phone number"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="status"
                        name="status"
                        placeholder="e.g. 01xxx xxx xxx"
                        value={newOrderType.status || ""}
                        required
                        onChange={handleSetNewOrderType}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="address" className="form-label">
                        {_t(t("Address"))}
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="address"
                        name="address"
                        placeholder="Type order type address"
                        value={newOrderType.address || ""}
                        onChange={handleSetNewOrderType}
                      />
                    </div>

                    <div className="mt-4">
                      <div className="row">
                        <div className="col-6">
                          {SAAS_APPLICATION == "YES"
                            ? [
                                newOrderType.edit
                                  ? [
                                      <button
                                        type="submit"
                                        className="btn btn-success w-100 xsm-text text-uppercase t-width-max"
                                      >
                                        Update
                                      </button>,
                                    ]
                                  : [
                                      checkOrderTypeLimitState ==
                                      "HAS-LIMIT" ? (
                                        <button
                                          type="submit"
                                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max"
                                        >
                                          {!newOrderType.edit
                                            ? _t(t("Save"))
                                            : _t(t("Update"))}
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          className="btn btn-primary xsm-text text-uppercase btn-lg btn-block"
                                          onClick={() => {
                                            toast.error(
                                              `${"Your limit has expired"}`,
                                              {
                                                position: "bottom-center",
                                                autoClose: 5000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                className:
                                                  "text-center toast-notification",
                                              }
                                            );
                                          }}
                                        >
                                          {_t(t("disable"))}
                                        </button>
                                      ),
                                    ],
                              ]
                            : [
                                <button
                                  type="submit"
                                  className="btn btn-success w-100 xsm-text text-uppercase t-width-max"
                                >
                                  {!newOrderType.edit
                                    ? _t(t("Save"))
                                    : _t(t("Update"))}
                                </button>,
                              ]}
                        </div>
                        <div className="col-6">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row">
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newOrderType.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {newOrderType.uploading === true || loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        <CustomSpinLoader loading={loading || dataPaginating}/>
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!searchedOrderType.searched
                                    ? _t(t("Order Type List"))
                                    : _t(t("Search Result"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          {/* <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center">
                              
                              <div className="col-md-9 t-mb-15 mb-md-0">
                                <div className="input-group">
                                  <div className="form-file">
                                    <input
                                      type="text"
                                      className="form-control border-0 form-control--light-1 rounded-0"
                                      placeholder={_t(t("Search")) + ".."}
                                      onChange={handleSearch}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              <div className="col-md-3 text-md-right">
                                {SAAS_APPLICATION == 'YES' ? [
                                  checkOrderTypeLimitState == 'HAS-LIMIT' ? <button
                                    type="button"
                                    className="btn btn-primary xsm-text text-uppercase btn-lg btn-block"
                                    data-toggle="modal"
                                    data-target="#addOrderType"
                                    onClick={() => {
                                      setNewOrderType({
                                        ...newOrderType,
                                        edit: false,
                                        uploading: false,
                                      });
                                    }}
                                  >
                                    {_t(t("add new"))}
                                  </button> : <button
                                    type="button"
                                    className="btn btn-primary xsm-text text-uppercase btn-lg btn-block"
                                    onClick={() => {
                                      toast.error(`Your limit has expired`, {
                                        position: "bottom-center",
                                        autoClose: 10000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        className: "text-center toast-notification",
                                      });
                                    }}
                                  >
                                    {_t(t("add new"))}
                                  </button>
                                ] : [
                                  <button
                                    type="button"
                                    className="btn btn-primary xsm-text text-uppercase btn-lg btn-block"
                                    data-toggle="modal"
                                    data-target="#addOrderType"
                                    onClick={() => {
                                      setNewOrderType({
                                        ...newOrderType,
                                        edit: false,
                                        uploading: false,
                                      });
                                    }}
                                  >
                                    {_t(t("add new"))}
                                  </button>
                                ]}
                              </div>
                            </div>
                          </div> */}
                        </div>
                        {/* Table */}
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover min-table-height">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("S/L"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Name"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Status"))}
                                </th>
                                {/* <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Phn no"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Action"))}
                                </th> */}
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                              {!searchedOrderType.searched
                                ? [
                                    orderTypeList && [
                                      orderTypeList.data.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        orderTypeList.data.map(
                                          (item, index) => {
                                            return (
                                              <tr
                                                className="align-middle"
                                                key={index}
                                              >
                                                <th
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {index +
                                                    1 +
                                                    (orderTypeList.current_page -
                                                      1) *
                                                      orderTypeList.per_page}
                                                </th>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.name}
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  <Switch
                                                    checked={
                                                      item.status === "On"
                                                        ? 1
                                                        : 0
                                                    }
                                                    onChange={() => {
                                                      handleStatus(
                                                        item.id,
                                                        item.status
                                                      );
                                                    }}
                                                    height={22}
                                                    width={44}
                                                    offColor="#ee5253"
                                                  />
                                                </td>

                                                {/* <td className="xsm-text align-middle text-center">
                                              {item.status ? (
                                                <a
                                                  href={`tel:${item.status}`}
                                                  rel="noopener noreferrer"
                                                >
                                                  {item.status}
                                                </a>
                                              ) : (
                                                "-"
                                              )}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <div className="dropdown">
                                                <button
                                                  className="btn t-bg-clear t-text-dark--light-40"
                                                  type="button"
                                                  data-toggle="dropdown"
                                                >
                                                  <i className="fa fa-ellipsis-h"></i>
                                                </button>
                                                <div className="dropdown-menu">
                                                  <button
                                                    className="dropdown-item sm-text text-capitalize"
                                                    onClick={() =>
                                                      handleSetEdit(item.slug)
                                                    }
                                                    data-toggle="modal"
                                                    data-target="#addOrderType"
                                                  >
                                                    <span className="t-mr-8">
                                                      <i className="fa fa-pencil"></i>
                                                    </span>
                                                    {_t(t("Edit"))}
                                                  </button>

                                                  {SAAS_APPLICATION == "YES" ? null : [
                                                    <button
                                                      className="dropdown-item sm-text text-capitalize"
                                                      onClick={() => {
                                                        handleDeleteConfirmation(
                                                          item.slug
                                                        );
                                                      }}
                                                    >
                                                      <span className="t-mr-8">
                                                        <i className="fa fa-trash"></i>
                                                      </span>
                                                      {_t(t("Delete"))}
                                                    </button>
                                                  ]}
                                                </div>
                                              </div>
                                            </td> */}
                                              </tr>
                                            );
                                          }
                                        )
                                      ),
                                    ],
                                  ]
                                : [
                                    /* searched data, logic === haveData*/
                                    searchedOrderType && [
                                      searchedOrderType.list.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        searchedOrderType.list.map(
                                          (item, index) => {
                                            return (
                                              <tr
                                                className="align-middle"
                                                key={index}
                                              >
                                                <th
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {index +
                                                    1 +
                                                    (orderTypeList.current_page -
                                                      1) *
                                                      orderTypeList.per_page}
                                                </th>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.name}
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.address || "-"}
                                                </td>

                                                <td className="xsm-text align-middle text-center">
                                                  {item.status ? (
                                                    <a
                                                      href={`tel:${item.status}`}
                                                      rel="noopener noreferrer"
                                                    >
                                                      {item.status}
                                                    </a>
                                                  ) : (
                                                    "-"
                                                  )}
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  <div className="dropdown">
                                                    <button
                                                      className="btn t-bg-clear t-text-dark--light-40"
                                                      type="button"
                                                      data-toggle="dropdown"
                                                    >
                                                      <i className="fa fa-ellipsis-h"></i>
                                                    </button>
                                                    <div className="dropdown-menu">
                                                      <button
                                                        className="dropdown-item sm-text text-capitalize"
                                                        onClick={() =>
                                                          handleSetEdit(
                                                            item.slug
                                                          )
                                                        }
                                                        data-toggle="modal"
                                                        data-target="#addBranch"
                                                      >
                                                        <span className="t-mr-8">
                                                          <i className="fa fa-pencil"></i>
                                                        </span>
                                                        {_t(t("Edit"))}
                                                      </button>

                                                      <button
                                                        className="dropdown-item sm-text text-capitalize"
                                                        onClick={() => {
                                                          handleDeleteConfirmation(
                                                            item.slug
                                                          );
                                                        }}
                                                      >
                                                        <span className="t-mr-8">
                                                          <i className="fa fa-trash"></i>
                                                        </span>
                                                        {_t(t("Delete"))}
                                                      </button>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                      ),
                                    ],
                                  ]}
                            </tbody>
                          </table>
                        </div>
                      </div>                    
                  </div>
                </div>
              </div>

              {/* pagination loading effect */}
              {newOrderType.uploading === true || loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchedOrderType.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(orderTypeList, setPaginatedOrderType)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(orderTypeList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    setSearchedOrderType({
                                      ...searchedOrderType,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searchedOrderType,
                                    orderTypeForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default OrderTypeCrud;
